.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 999px;
  font-weight: 700;
  border: 2px solid transparent;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.primary {
  background: var(--color-primary);
  color: #fff;
}
.primary:hover:not(:disabled) {
  background: var(--color-primary-dark);
}
.secondary {
  background: #fff;
  color: var(--color-selected);
  border-color: var(--color-chip-border);
}
.secondary:hover:not(:disabled) {
  background: var(--color-hover-bg);
}
.danger {
  background: #fff;
  color: var(--color-danger);
  border-color: #f3c3be;
}
.danger:hover:not(:disabled) {
  background: var(--color-danger-bg);
}
.ghost {
  background: transparent;
  color: var(--color-link);
  padding: 0 10px;
}
.ghost:hover:not(:disabled) {
  background: var(--color-hover-bg);
}
.sm {
  min-height: 32px;
  padding: 0 12px;
  font-size: 14px;
}
.card {
  background: #fff;
  border: 1px solid var(--color-line);
  border-radius: 24px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cardHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.field > label,
.fieldLabel {
  font-weight: 600;
  font-size: 14px;
}
.input {
  border: 1px solid var(--color-chip-border);
  border-radius: 14px;
  padding: 9px 12px;
  min-height: 40px;
  background: #fff;
  color: var(--color-ink);
  width: 100%;
}
textarea.input {
  min-height: 120px;
  resize: vertical;
}
.hint {
  color: var(--color-muted);
  font-size: 13px;
}
.error {
  color: var(--color-danger);
  font-size: 13px;
  margin: 0;
}
.badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: var(--color-hover-bg);
  color: var(--color-selected);
}
.badgeGreen {
  background: var(--color-mint-bg);
  color: var(--color-mint-ink);
}
.badgeAmber {
  background: var(--color-warn-bg);
  color: var(--color-warn-ink);
}
.badgeRed {
  background: var(--color-danger-bg);
  color: var(--color-danger);
}
.table {
  width: 100%;
  border-collapse: collapse;
}
.table th,
.table td {
  text-align: left;
  padding: 10px 8px;
  border-bottom: 1px solid var(--color-line);
  vertical-align: top;
}
.table th {
  font-size: 12px;
  color: var(--color-muted);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.tableWrap {
  overflow-x: auto;
}
.empty {
  color: var(--color-muted);
  text-align: center;
  padding: 32px 16px;
}
.row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.grid2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
}
.meter {
  display: inline-flex;
  gap: 1px;
  line-height: 0;
}
.meter svg {
  width: 15px;
  height: 15px;
  fill: var(--color-meter-off);
}
.meter svg.on {
  fill: var(--color-meter);
}
.spinner {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 3px solid var(--color-meter-off);
  border-top-color: var(--color-primary);
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.center {
  display: flex;
  justify-content: center;
  padding: 40px;
}
.banner {
  border-radius: 16px;
  padding: 12px 14px;
  background: var(--color-warn-bg);
  color: var(--color-warn-ink);
}
.code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  background: var(--color-page);
  border: 1px solid var(--color-line);
  border-radius: 8px;
  padding: 8px 10px;
  overflow-wrap: anywhere;
}
.centerRow {
  justify-content: center;
}
.bare {
  border: 0;
  padding: 0;
  margin: 0;
}
.input[data-width='narrow'] {
  max-width: 280px;
}
.plainList {
  list-style: none;
  margin: 0;
  padding: 0;
}
.spread {
  justify-content: space-between;
}
.prewrap {
  white-space: pre-line;
  margin: 0;
  overflow-wrap: anywhere;
}

input[type='file']::file-selector-button {
  font: inherit;
  font-weight: 600;
  border: 1px solid var(--color-chip-border);
  background: #fff;
  color: var(--color-ink);
  border-radius: 999px;
  padding: 8px 16px;
  margin-right: 12px;
  cursor: pointer;
}

/* Emphasised card (e.g. the current plan): dark green with light text. */
.cardHighlight {
  background: var(--color-ink);
  border-color: var(--color-ink);
  color: #fff;
}
.cardHighlight .hint,
.cardHighlight li {
  color: #bfdccc;
}

.price {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 32px;
  letter-spacing: -0.04em;
}
.price small {
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  opacity: 0.75;
}
